import { Image } from '@chakra-ui/image'
import { Flex, Text } from '@chakra-ui/layout'
import { formatPrice } from '../../../../../utils/formatPrice'
import { useMarkup } from '../../contexts/MarkupProvider'
const imgLoading = '../../../../images/loading-blue.gif'

export function JurosLucro() {
  const { loading, summary } = useMarkup()

  const outrosLucros =
    summary?.lucroSobreFrete +
    summary?.lucroCondicaoPagamento +
    summary?.jurosPagamentoAtrasado +
    summary?.sobraInnovation

  const lucroBrutoTotal = summary?.lucroBruto

  return (
    <Flex flexDir="column" gap={1} w="100%">
      <Flex
        alignItems="flex-start"
        justifyContent="space-between"
        borderBottom="1px solid #ebebeb"
      >
        <Text fontFamily={'heading'} letterSpacing={'wide'}>
          Juros de pagamento atrasado
        </Text>
        <Text color="#1A8AB6">
          {isNaN(summary?.jurosPagamentoAtrasado) ? (
            <Image src={imgLoading} width="20px" />
          ) : loading ? (
            <Image src={imgLoading} width="20px" />
          ) : (
            formatPrice(summary?.jurosPagamentoAtrasado)
          )}
        </Text>
      </Flex>
      <Flex
        alignItems="flex-start"
        justifyContent="space-between"
        borderBottom="1px solid #ebebeb"
      >
        <Text fontFamily={'heading'} letterSpacing={'wide'}>
          Lucro sobre condição de pagamento
        </Text>
        <Text color="#1A8AB6">
          {isNaN(summary?.lucroCondicaoPagamento) ? (
            <Image src={imgLoading} width="20px" />
          ) : loading ? (
            <Image src={imgLoading} width="20px" />
          ) : (
            formatPrice(summary?.lucroCondicaoPagamento)
          )}
        </Text>
      </Flex>
      <Flex
        alignItems="flex-start"
        justifyContent="space-between"
        borderBottom="1px solid #ebebeb"
      >
        <Text fontFamily={'heading'} letterSpacing={'wide'}>
          Lucro sobre frete
        </Text>
        <Text color="#1A8AB6">
          {isNaN(summary?.lucroSobreFrete) ? (
            <Image src={imgLoading} width="20px" />
          ) : loading ? (
            <Image src={imgLoading} width="20px" />
          ) : (
            formatPrice(summary?.lucroSobreFrete)
          )}
        </Text>
      </Flex>
      <Flex
        alignItems="flex-start"
        justifyContent="space-between"
        borderBottom="1px solid #ebebeb"
      >
        <Text fontFamily={'heading'} letterSpacing={'wide'}>
          Sobra innovation
        </Text>
        <Text color="#1A8AB6">
          {isNaN(summary?.sobraInnovation) ? (
            <Image src={imgLoading} width="20px" />
          ) : loading ? (
            <Image src={imgLoading} width="20px" />
          ) : (
            formatPrice(summary?.sobraInnovation)
          )}
        </Text>
      </Flex>
      <Flex
        alignItems="flex-start"
        justifyContent="space-between"
        borderBottom="1px solid #ebebeb"
      >
        <Text fontFamily={'heading'} letterSpacing={'wide'}>
          Outros lucros
        </Text>
        <Text color="#1A8AB6">
          {isNaN(outrosLucros) ? (
            <Image src={imgLoading} width="20px" />
          ) : loading ? (
            <Image src={imgLoading} width="20px" />
          ) : (
            formatPrice(outrosLucros)
          )}
        </Text>
      </Flex>
      <Flex
        alignItems="flex-start"
        justifyContent="space-between"
        borderBottom="1px solid #ebebeb"
      >
        <Text fontFamily={'heading'} letterSpacing={'wide'}>
          Lucro bruto pedidos
        </Text>
        <Text color="#1A8AB6">
          {isNaN(lucroBrutoTotal) ? (
            <Image src={imgLoading} width="20px" />
          ) : loading ? (
            <Image src={imgLoading} width="20px" />
          ) : (
            formatPrice(lucroBrutoTotal)
          )}
        </Text>
      </Flex>
    </Flex>
  )
}
